var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { loggerMiddleware, RelayNetworkLayer, cacheMiddleware, } from 'react-relay-network-modern/es';
import logger from '../../../config/app.logger';
import { getExtendedLogger } from '../../Logger';
import { LOGGER_NAME } from '../constants';
import minificationMiddleware from './middlewares/minification';
import operationNameMiddleware from './middlewares/operationName';
var log = getExtendedLogger(LOGGER_NAME, logger);
export var createNetwork = function (middlewares, _a) {
    if (_a === void 0) { _a = {}; }
    var minification = _a.minification, cacheOptions = _a.cacheOptions, getPersistedQueriesMap = _a.getPersistedQueriesMap, options = __rest(_a, ["minification", "cacheOptions", "getPersistedQueriesMap"]);
    var defaultMiddlewares = [
        loggerMiddleware({
            logger: log.bind(log, '[RELAY-API-CALL]'),
        }),
        operationNameMiddleware(),
        minificationMiddleware({
            minification: minification || false,
            getPersistedQueriesMap: getPersistedQueriesMap,
        }),
        cacheMiddleware(cacheOptions),
    ];
    return new RelayNetworkLayer(__spread(middlewares, defaultMiddlewares), options);
};
//# sourceMappingURL=network.js.map